<template lang="html">
  <div>
    <v-app-bar app flat color="white" height="72" extended extension-height="1">
      <v-container class="px-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex align-center">
              <v-btn icon width="40" height="40" class="mr-2" @click="sidebar_active = true">
                <v-icon>
                  mdi-menu
                </v-icon>
              </v-btn>
              <template v-if="$store.state.selected_outlet">
                <div class="store-name-text">
                  {{ $store.state.selected_outlet.name }}
                </div>
              </template>
              <v-spacer />
              <div v-if="$store.state.selected_type === 'DINE-IN'" class="d-flex align-center">
                <div class="wrap-table">
                  <div class="wrap-table-icon">
                    <img :src="icon_table" :alt="$t('table')">
                  </div>
                  <div class="wrap-table-content">
                    <div class="wrap-table-text">
                      {{ $t('table') }} {{ noTable }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <div :class="['sidebar-overlay', { 'active': sidebar_active }]" @click="sidebar_active = false" />
    <sidebar-menu v-model="sidebar_active" :list-menu="menu" :sidebar-active="nav_group" :has-combo="total_combo !== 0" :click-menu="scrollTo" :scroll-menu="scrollItemMenu" @triggerLoadProduct="loadProduct" />
    <banner :items="banners" :click-detail="detailBanner" />
    <div class="container-top">
      <div class="container-top-menu">
        <v-container class="py-0">
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="py-0">
              <div>
                <div class="d-flex align-center my-2">
                  <div :class="['back-search animation-search', { 'hide': !is_search }]">
                    <v-btn icon @click="is_search = false">
                      <v-icon>
                        mdi-arrow-left
                      </v-icon>
                    </v-btn>
                  </div>
                  <div :class="['input-search animation-search', { 'show-search': is_search }]">
                    <v-text-field
                      prepend-inner-icon="mdi-magnify"
                      :placeholder="$t('v2.search')"
                      hide-details
                      rounded
                      clearable
                      outlined
                      color="olbrand"
                      height="40"
                      dense
                      @focus="is_search = true"
                      @input="searchProduct"
                    />
                  </div>
                  <div class="ml-1">
                    <div v-ripple :class="['nav-filter', { 'active': is_filter }]" @click="is_filter = !is_filter">
                      <div class="wrap-nav-filter">
                        <div class="wrap-nav-filter-icon">
                          <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.25 0.75H1.58329C1.07638 0.75 0.666626 1.15975 0.666626 1.66667V4.04083C0.666626 4.52025 0.861876 4.99142 1.20104 5.33058L6.16663 10.2962V17.25C6.16663 17.5681 6.33163 17.8623 6.60204 18.0301C6.74871 18.1208 6.91554 18.1667 7.08329 18.1667C7.22354 18.1667 7.36379 18.1346 7.49304 18.0704L11.1597 16.2371C11.4705 16.0813 11.6666 15.7641 11.6666 15.4167V10.2962L16.6322 5.33058C16.9714 4.99142 17.1666 4.52025 17.1666 4.04083V1.66667C17.1666 1.15975 16.7569 0.75 16.25 0.75ZM10.1019 9.26858C9.92954 9.44 9.83329 9.67283 9.83329 9.91667V14.8502L7.99996 15.7668V9.91667C7.99996 9.67283 7.90371 9.44 7.73138 9.26858L2.49996 4.04083V2.58333H15.3342L15.336 4.03442L10.1019 9.26858Z" fill="#272727" />
                          </svg>
                        </div>
                        <div class="wrap-nav-filter-content">
                          <div class="wrap-nav-filter-content-text">
                            Filter
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div :class="['col-filter-view animation-search', { 'hide': is_search }]">
                    <div class="d-flex align-centter">
                      <!-- <div class="ml-2">
                        <v-btn icon :disabled="is_list" :class="[`br-5 btn-filter`, { 'active' : is_list }]" @click="is_list = !is_list">
                          <v-icon>
                            mdi-format-list-bulleted
                          </v-icon>
                        </v-btn>
                      </div> -->
                      <div class="ml-1">
                        <v-btn icon :class="[`br-5 btn-filter`]" @click="is_list = !is_list">
                          <v-icon v-if="!is_list">
                            mdi-format-list-bulleted
                          </v-icon>
                          <v-icon v-else>
                            mdi-view-grid-outline
                          </v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div class="row-toggle-wrapper" :style="{ height: rowToggleHeight + 'px' }">
        <div :class="['row-filter', { 'active': is_filter }]">
          <v-container class="py-0">
            <v-row>
              <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
                <div>
                  <div ref="verticalScroll" class="wrap-filter-scroll" @mousedown="onMouseDown" @mouseup="onMouseUp">
                    <div class="content-filter-scroll">
                      <div class="filter-type-component">
                        <div :class="['chip-filter', { 'active': filter.is_discount }]" @click="filterDiscount">
                          <div class="chip-filter-icon">
                            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M0.666626 4.50002C0.666626 3.76316 1.2631 3.16669 1.99996 3.16669H14C14.7368 3.16669 15.3333 3.76316 15.3333 4.50002V7.83335H14.0713C13.6841 7.83335 13.3891 8.09745 13.3426 8.38312C13.2737 8.80654 13.5945 9.16669 14 9.16669H15.3333V12.5C15.3333 13.2369 14.7368 13.8334 14 13.8334H1.99996C1.2631 13.8334 0.666626 13.2369 0.666626 12.5V9.16669H1.99996C2.40543 9.16669 2.72623 8.80656 2.65729 8.38315C2.61079 8.09748 2.31586 7.83335 1.92863 7.83335H0.666626V4.50002ZM14 4.50002H1.99996V6.50125C2.91628 6.53282 3.81068 7.16983 3.9733 8.16892C4.17636 9.41617 3.21448 10.5 1.99996 10.5V12.5H14V10.5C12.7854 10.5 11.8236 9.41614 12.0266 8.16889C12.1893 7.16982 13.0836 6.53282 14 6.50125V4.50002ZM7.99996 5.16669V6.50002H6.66663V5.16669H7.99996ZM7.99996 7.83335V9.16669H6.66663V7.83335H7.99996ZM7.99996 10.5V11.8334H6.66663V10.5H7.99996Z" fill="#F44336" />
                            </svg>
                          </div>
                          <div class="chip-filter-content">
                            <div class="chip-filter-text">
                              {{ $t('v2.discount') }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="filter-type-component">
                        <div :class="['chip-filter chip-filter-price', { 'active': filter.is_sort_price !== '' }]" @click="filterSortPrice">
                          <div class="chip-filter-icon">
                            <svg v-if="filter.is_sort_price !== 'down'" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7.33335 6.10931V12.5H8.66669V6.10931L11.5287 8.97131L12.4714 8.02865L8.00002 3.55731L3.52869 8.02865L4.47135 8.97131L7.33335 6.10931Z" fill="#272727" />
                            </svg>
                            <svg v-else width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12.4712 8.97133L11.5286 8.02867L8.66656 10.8907V4.5H7.33323V10.8907L4.47123 8.02867L3.52856 8.97133L7.9999 13.4427L12.4712 8.97133Z" fill="#272727" />
                            </svg>
                          </div>
                          <div class="chip-filter-content">
                            <div class="chip-filter-text">
                              <template v-if="filter.is_sort_price === 'up'">
                                {{ $t('v2.sort_price_up') }}
                              </template>
                              <template v-else-if="filter.is_sort_price === 'down'">
                                {{ $t('v2.sort_price_down') }}
                              </template>
                              <template v-else>
                                {{ $t('v2.sort_price') }}
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="filter-type-component" @click="filterSortCollection">
                        <div class="chip-filter">
                          <div class="chip-filter-icon">
                            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M2.6665 4.5H3.99984V5.83333H2.6665V4.5ZM2.6665 7.83333H3.99984V9.16667H2.6665V7.83333ZM2.6665 11.1667H3.99984V12.5H2.6665V11.1667ZM13.3332 5.83333V4.5H12.5332H6.13317H5.3485V5.83333H6.13317H12.5332H13.3332ZM5.33317 7.83333H13.3332V9.16667H5.33317V7.83333ZM5.33317 11.1667H13.3332V12.5H5.33317V11.1667Z" fill="#272727" />
                            </svg>
                          </div>
                          <div class="chip-filter-content">
                            <div class="chip-filter-text">
                              <template v-if="collections.length === 1">
                                {{ collections[0].collection_name }}
                              </template>
                              <template v-else>
                                {{ $t('v2.collection') }}
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
        <div :class="['container-top-tabs row-group', { 'active': !is_searching && !is_filter }]">
          <v-container class="py-0">
            <v-row>
              <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
                <div ref="group-nav" class="_tabs">
                  <div class="_tabs-group">
                    <div id="scroll-menu" class="slide-group-wrapper">
                      <div ref="all-nav" v-scroll:#scroll-menu="onScrollMenu" class="slide-group-content" :style="{ transform: 'translateX(' + menu_translateX + 'px)' }">
                        <div class="tabs-slider-wrapper" :style="{ left: (active_tab.left + 12) + 'px', width: active_tab.width + 'px' }" />
                        <div v-if="total_combo > 0" :class="['tab-item tab-item-0', { 'active': nav_group[0] === true }]" @click="scrollTo()">
                          {{ $t('v2.combo') }}
                        </div>
                        <div v-for="(item, idx) in menu" :key="idx + '-menu'" :class="['tab-item', 'tab-item-' + (idx + 1), { 'active': total_combo > 0 ? nav_group[idx + 1] : nav_group[idx] }]" @click="handleClickMenu(item.id, idx)">
                          {{ item.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
        <div :class="['container-top-tabs row-result-search', { 'active': is_searching && (total_product + total_combo) !== 0 }]">
          <v-container class="py-0">
            <v-row>
              <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="py-0">
                <div class="d-flex align-center font-16 font-weight-600" style="height: 48px;">
                  {{ $t('v2.menu_found', { total: total_product + total_combo }) }}
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </div>
    </div>
    <v-container v-if="!$isEmpty($store.state.selected_outlet)" class="pt-0" :style="[cart.item && typeof cart.item !== 'undefined' && cart.item.length !== 0 ? `margin-bottom: 66px`: '']">
      <v-row>
        <v-col v-if="product_favorite.length > 0 && !is_searching && $store.state.selected_outlet.show_product_favorite" cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
          <div>
            <slide-col-product :key="0 + '-favorite'" :ref="'list-favorite'" :section-id="'list-favorite'" :title="'Favorite 💗'" :items="product_favorite" :click-detail="detailFavorite" />
          </div>
        </v-col>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
          <div v-if="combos.length !== 0 || products.length !== 0" v-scroll="onScrollItem">
            <products v-if="combos.length > 0" :key="0 + '-combo'" :ref="'list-combo'" :is-list="is_list" :section-id="'list-combo'" :title="$t('v2.combo')" :items="combos" is-combo :click-detail="detailProductCombo" />
            <products v-for="(item, idx) in products" :key="idx" :ref="'list-product-' + item.product_group_id" :is-list="is_list" :section-id="'list-product-' + item.product_group_id" :title="item.product_group_name" :items="item.items" :click-detail="detailProduct" />
          </div>
          <div v-else-if="is_searching && (!product_search && !combo_search) && (total_product + total_combo === 0) && !loading.product" class="text-center mt-10">
            <div class="mb-2">
              <img src="@/assets/images/v2/img/no_data.png" alt="No data" class="image-90">
            </div>
            <div class="font-18 font-weight-700">
              {{ $t('v2.menu_not_found') }}
            </div>
            <div class="font-14 font-weight-400">
              {{ $t('v2.try_with_another_keyword') }}
            </div>
          </div>
          <custom-skeleton-list v-if="loading.product && is_list" :is-first="isFirst" />
          <custom-skeleton-grid v-if="loading.product && !is_list" :is-first="isFirst" />
          <product v-if="detail_product.sheet" v-model="detail_product" :default-data="detail_product.default" :click-addcart="addCart" :selected-idx-commodity="{selectedCommodity, combo_index}" @listcombo="openListCombo" />
          <list-combo v-model="selectedCommodity" :open.sync="sheet_list_combo" :commodity="list_commodity" />
        </v-col>
      </v-row>
    </v-container>
    <div v-if="cart.item && typeof cart.item !== 'undefined' && cart.item.length !== 0" class="item-cart">
      <v-container class="pa-0">
        <v-row class="ma-0">
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
            <div class="chackout-floating">
              <div v-if="!$isEmpty(cart.discount_detail) && typeof cart.discount_voucher_id !== 'undefined'" class="chackout-potential-discount">
                <div class="flex-image flex-image-center">
                  <div class="flex-image-avatar mr-1">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_5643_24721)">
                        <path d="M15.2652 7.50803L11.3101 6.04403L9.83323 1.20358C9.77634 1.01692 9.60345 0.888916 9.40834 0.888916C9.21323 0.888916 9.04034 1.01692 8.98345 1.20358L7.50701 6.04403L3.55145 7.50803C3.37679 7.57292 3.26123 7.73869 3.26123 7.92492C3.26123 8.11069 3.37679 8.27736 3.55145 8.3418L7.50479 9.80536L8.98212 14.7934C9.03812 14.9818 9.21145 15.1111 9.40834 15.1111C9.60479 15.1111 9.77856 14.9818 9.83456 14.7929L11.3119 9.80492L15.2657 8.34136C15.4395 8.27736 15.5555 8.11114 15.5555 7.92492C15.5555 7.73914 15.4395 7.57292 15.2652 7.50803Z" fill="#FFAC33" />
                        <path d="M6.37634 12.3973L5.34789 12.0168L4.94789 10.5502C4.89545 10.3564 4.71989 10.2222 4.51945 10.2222C4.319 10.2222 4.14345 10.3564 4.09056 10.5497L3.69056 12.0164L2.66256 12.3968C2.48789 12.4613 2.37234 12.628 2.37234 12.8137C2.37234 12.9995 2.48789 13.1662 2.66256 13.2306L3.68522 13.6097L4.08834 15.2195C4.13811 15.4168 4.31545 15.5555 4.51945 15.5555C4.72345 15.5555 4.90078 15.4168 4.95056 15.2191L5.35367 13.6093L6.37634 13.2302C6.551 13.1662 6.66656 12.9995 6.66656 12.8137C6.66656 12.628 6.551 12.4613 6.37634 12.3973ZM4.44834 2.76928L3.39767 2.3804L3.00834 1.32928C2.94389 1.15462 2.77767 1.03906 2.59145 1.03906C2.40567 1.03906 2.23945 1.15462 2.17456 1.32928L1.78567 2.3804L0.734558 2.76928C0.559891 2.83417 0.444336 3.0004 0.444336 3.18617C0.444336 3.37195 0.559891 3.53862 0.734558 3.60306L1.78567 3.99195L2.17456 5.04306C2.23945 5.21773 2.40567 5.33328 2.59145 5.33328C2.77722 5.33328 2.94345 5.21773 3.00834 5.04306L3.39722 3.99195L4.44834 3.60306C4.623 3.53817 4.73856 3.37195 4.73856 3.18617C4.73856 3.0004 4.623 2.83417 4.44834 2.76928Z" fill="#FFCC4D" />
                      </g>
                      <defs>
                        <clipPath id="clip0_5643_24721">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div class="flex-image-content">
                    <div class="flex-image-content-text font-11 font-weight-400">
                      {{ $t('v2.congratulations_you_saved', { price: priceFormat(Number(cart.discount_detail.discount_to_amount)) }) }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="!$isEmpty(potential_discount)" class="chackout-potential-discount">
                <div class="flex-image flex-image-center">
                  <div class="flex-image-avatar mr-1">
                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_5797_4384)">
                        <path d="M15.7652 7.50803L11.8101 6.04403L10.3332 1.20358C10.2763 1.01692 10.1035 0.888916 9.90834 0.888916C9.71323 0.888916 9.54034 1.01692 9.48345 1.20358L8.00701 6.04403L4.05145 7.50803C3.87679 7.57292 3.76123 7.73869 3.76123 7.92492C3.76123 8.11069 3.87679 8.27736 4.05145 8.3418L8.00479 9.80536L9.48212 14.7934C9.53812 14.9818 9.71145 15.1111 9.90834 15.1111C10.1048 15.1111 10.2786 14.9818 10.3346 14.7929L11.8119 9.80492L15.7657 8.34136C15.9395 8.27736 16.0555 8.11114 16.0555 7.92492C16.0555 7.73914 15.9395 7.57292 15.7652 7.50803Z" fill="#FFAC33" />
                        <path d="M6.87634 12.3973L5.84789 12.0168L5.44789 10.5502C5.39545 10.3564 5.21989 10.2222 5.01945 10.2222C4.819 10.2222 4.64345 10.3564 4.59056 10.5497L4.19056 12.0164L3.16256 12.3968C2.98789 12.4613 2.87234 12.628 2.87234 12.8137C2.87234 12.9995 2.98789 13.1662 3.16256 13.2306L4.18522 13.6097L4.58834 15.2195C4.63811 15.4168 4.81545 15.5555 5.01945 15.5555C5.22345 15.5555 5.40078 15.4168 5.45056 15.2191L5.85367 13.6093L6.87634 13.2302C7.051 13.1662 7.16656 12.9995 7.16656 12.8137C7.16656 12.628 7.051 12.4613 6.87634 12.3973ZM4.94834 2.76928L3.89767 2.3804L3.50834 1.32928C3.44389 1.15462 3.27767 1.03906 3.09145 1.03906C2.90567 1.03906 2.73945 1.15462 2.67456 1.32928L2.28567 2.3804L1.23456 2.76928C1.05989 2.83417 0.944336 3.0004 0.944336 3.18617C0.944336 3.37195 1.05989 3.53862 1.23456 3.60306L2.28567 3.99195L2.67456 5.04306C2.73945 5.21773 2.90567 5.33328 3.09145 5.33328C3.27722 5.33328 3.44345 5.21773 3.50834 5.04306L3.89722 3.99195L4.94834 3.60306C5.123 3.53817 5.23856 3.37195 5.23856 3.18617C5.23856 3.0004 5.123 2.83417 4.94834 2.76928Z" fill="#FFCC4D" />
                      </g>
                      <defs>
                        <clipPath id="clip0_5797_4384">
                          <rect width="16" height="16" fill="white" transform="translate(0.5)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div class="flex-image-content">
                    <div class="flex-image-content-text font-11 font-weight-400">
                      {{ potential_discount.remaining_amount_left > 0 ? $t('v2.potential_discount', { price: priceFormat(Number(potential_discount.remaining_amount_left)) }) : $t('v2.there_is_promotion_available_for_you') }} <span class="font-weight-bold font-12 olbrand--text cursor-pointer" @click="showSelectedDiscount(potential_discount.id)">{{ $t('v2.view_voucher') }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="nav-checkout" @click="goToCheckout">
                <span v-mask-money="data_cart.sub_total" class="font-16 font-weight-700" />
                <v-spacer />
                <div class="nav-checkout-text">
                  <div class="font-16 font-weight-700">
                    {{ $t('v2.checkout') }}
                  </div>
                  <div class="ml-2">
                    <v-icon color="white" size="18" class="shake-icon">
                      mdi-arrow-right
                    </v-icon>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-bottom-sheet v-model="dialog.voucher_detail" content-class="dialog-icon">
      <div class="position-relative">
        <v-btn fab small color="white" class="btn-close-dialog-icon" @click="dialog.voucher_detail = false">
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <v-sheet class="sheet-border">
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <template v-if="!$isEmpty(voucher_detail)">
                <div class="py-2 mb-8">
                  <div class="mt-2 font-18 font-weight-700">
                    {{ voucher_detail.title }}
                  </div>
                  <div v-if="voucher_detail.fexpiry_date" class="font-12 font-weight-400 ol-grey-content">
                    {{ $t('v2.expire_on') }} {{ voucher_detail.fexpiry_date }}
                  </div>
                </div>
                <div class="pa-4 br-8 bg-grey" :style="{ marginBottom: !voucher_detail.can_use ? '150px' : '64px' }">
                  <div class="font-weight-600 mb-2">
                    {{ $t('v2.terms_and_conditions') }}
                  </div>
                  <div class="font-14" v-html="voucher_detail.discount_description" />
                </div>
                <div class="section-bottom absolute white ol-min-elevation-2">
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="py-0">
                        <div v-if="!voucher_detail.can_use" class="mb-3">
                          <div class="flex-image pa-4 bg-orange-soft br-8">
                            <div class="mr-2">
                              <v-icon size="24" color="olorange">
                                mdi-alert-outline
                              </v-icon>
                            </div>
                            <div class="flex-image-content">
                              <div class="flex-image-content-text font-14 font-weight-600 ol-black">
                                {{ $t('v2.voucher_does_not_meet_the_terms_and_conditions') }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <v-btn v-if="!$isEmpty(cart.discount_detail)" block color="white" height="40" class="text-none br-5 letter-spacing-normal font-weight-700 ol-red ol-elevation-1" @click="deleteVoucher(voucher_detail.id)">
                          {{ $t('v2.delete_voucher') }}
                        </v-btn>
                        <v-btn v-else block color="primary" :disabled="!voucher_detail.can_use" height="40" class="text-none br-5 letter-spacing-normal font-weight-700" @click="hitVoucher(voucher_detail.id)">
                          {{ $t('v2.use_voucher') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
              </template>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="dialog.collection" persistent content-class="sheet-full sheet-collection">
      <v-sheet style="height: 100%" class="br-0">
        <div class="sheet-app-bar">
          <div class="sheet-app-bar-content">
            <v-container class="px-0">
              <v-row>
                <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
                  <div class="d-flex align-center">
                    <div class="font-20 font-weight-bold">
                      {{ $t('v2.select_collection') }}
                    </div>
                    <v-spacer />
                    <v-btn icon width="40" height="40" @click="closeDialogCollection">
                      <v-icon>
                        mdi-close
                      </v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </div>
        <div>
          <v-container class="pt-0">
            <v-row>
              <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
                <template v-if="collections.length > 0">
                  <div class="mt-4" style="margin-bottom: 60px;">
                    <div class="checkbox-between-list">
                      <div v-for="(item, idx) in collections" :key="idx">
                        <div class="checkbox-between-item">
                          <div class="checkbox-between-content">
                            <div class="checkbox-between-title font-weight-600">
                              {{ item.collection_name }}
                            </div>
                          </div>

                          <div class="checkbox-between-action">
                            <v-checkbox
                              v-model="item_collection[idx]"
                              hide-details
                              class="mt-0 pt-0 ml-2"
                            />
                          </div>
                        </div>

                        <div v-if="idx + 1 !== collections.length" class="py-2">
                          <hr class="line-variant">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="section-bottom white">
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="py-0">
                          <v-btn block color="primary" height="40" class="text-none font-weight-700 btn-v2-shadow" @click="applyCollection">
                            {{ $t('v2.apply') }} {{ totalSelectedCollection > 0 ? '(' + totalSelectedCollection + ')' : '' }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </div>
                </template>
                <div v-else class="mt-10 text-center" style="margin-bottom: 60px;">
                  <div class="mb-2">
                    <img src="@/assets/images/v2/img/no_data.png" alt="No data" class="image-90">
                  </div>
                  <div class="font-18 font-weight-700">
                    {{ $t('v2.collection_not_found') }}
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<script>
import { debounce } from 'debounce'
import {
  getData as getProduct,
  getDetail as getDetailProduct,
  getDataCombo as getProductCombo,
  getDetailCombo as getDetailProductCombo,
  getProductGroup as getGroupList,
  getDataFavoriteV2,
  getDataCollection
} from '@/api/product'
import {
  getBanner
} from '@/api/setting'
import {
  getDataDetailValidate as getDiscountDetail,
  hitDiscount as hitDataDiscount,
  hitPotentialDiscount as hitDataPotentialDiscount
} from '@/api/discount'
import SidebarMenu from '@/components/v2/SidebarMenu'
import Banner from '@/components/v2/product/Banner'
import SlideColProduct from '@/components/v2/product/SlideColProduct'
import Products from '@/components/v2/product/Products'
import Product from '@/components/v2/product/Product'
import ListCombo from '@/components/v2/product/ListCombo'
import CustomSkeletonList from '@/components/v2/CustomSkeleton/List'
import CustomSkeletonGrid from '@/components/v2/CustomSkeleton/Grid'
export default {
  components: {
    SidebarMenu,
    Banner,
    SlideColProduct,
    Products,
    Product,
    ListCombo,
    CustomSkeletonList,
    CustomSkeletonGrid
  },
  data() {
    return {
      loading: {
        product: false
      },
      dialog: {
        voucher_detail: false,
        collection: false
      },
      voucher_detail: {},
      filter: {
        is_discount: false,
        is_sort_price: ''
      },
      sidebar_active: false,
      icon_table: require('@/assets/images/v2/img/icon_table.png'),
      is_list: true,
      settingScroll: {
        product: false,
        combo: false,
        group: false
      },
      params: {
        show_collections: 0,
        collections: [],
        search_column: [],
        search_operator: [],
        search_text: [],
        sort_column: [],
        sort_type: [],
        page: 1,
        per_page: 20,
        page_combo: 1,
        per_page_combo: 20,
        page_group: 1,
        per_page_group: 20,
        remark: '',
        price: ''
      },
      products: [],
      product_favorite: [],
      total_product: 0,
      product_search: true,
      combos: [],
      total_combo: 0,
      combo_search: true,
      combo_meta_total: 0,
      detail_product: {
        type: 'product',
        sheet: false,
        item: {},
        method: 'add',
        default: {},
        key: null
      },
      cart: {
        item: []
      },
      detail_table: {},
      is_search: false,
      is_searching: false,
      is_filter: false,
      prevScrollpos: 0,
      currentScrollPos: 0,
      menu: [],
      total_menu: 0,
      active_tab: {
        left: 0,
        width: 0
      },
      nav_group: [],
      menu_translateX: 0,
      banners: [],
      collections: [],
      item_collection: [],
      selected_collection: [],
      cursorPos: [0, 0],
      verticalScroll: null,
      potential_discount: {},
      sheet_list_combo: false,
      list_commodity: [],
      selectedCommodity: [],
      combo_index: null
    }
  },
  computed: {
    rowToggleHeight() {
      if (this.is_filter) {
        return 55
      }
      if (this.is_searching) {
        return (this.total_product + this.total_combo) !== 0 ? 48 : 0
      }
      return 48
    },
    isFirst() {
      return this.params.page === 1 || this.params.page_combo === 1
    },
    totalSelectedCollection() {
      let total = 0
      for (let i = 0; i < this.item_collection.length; i++) {
        if (this.item_collection[i]) {
          total = total + 1
        }
      }
      return total
    },
    data_cart() {
      if (this.cart.item && this.cart.item.length > 0) {
        return this.cart.item.reduce((acc, curr) => {
          return {
            qty: acc.qty + curr.qty,
            sub_total: (typeof acc.sub_total !== 'undefined' ? acc.sub_total : 0) + (typeof curr.sub_total !== 'undefined' ? curr.sub_total : 0)
          }
        })
      } else {
        return {
          qty: 0,
          sub_total: 0
        }
      }
    },
    noTable() {
      if (!this.$isEmpty(this.detail_table) && !this.$isEmpty(this.detail_table.table_detail) && this.detail_table.table_detail.name) {
        return this.detail_table.table_detail.name
      } else {
        return ''
      }
    },
    dataParams() {
      var params = {
        page: this.params.page,
        per_page: this.params.per_page
      }
      if (this.params.search_column.length > 0) {
        params.search_column = this.params.search_column
        params.search_operator = this.params.search_operator
        params.search_text = this.params.search_text
      }
      params.show_collections = this.params.show_collections
      params.collections = this.params.collections
      params.sort_column = this.params.sort_column
      params.sort_type = this.params.sort_type
      params.remark = this.$store.state.selected_type
      params.price = this.params.price
      return params
    },
    dataParamsCombo() {
      var params = {
        page: this.params.page_combo,
        per_page: this.params.per_page_combo
      }
      if (this.params.search_column.length > 0) {
        params.search_column = this.params.search_column
        params.search_operator = this.params.search_operator
        params.search_text = this.params.search_text
      }
      params.show_collections = this.params.show_collections
      params.collections = this.params.collections
      params.sort_column = this.params.sort_column
      params.sort_type = this.params.sort_type
      params.remark = this.$store.state.selected_type
      params.price = this.params.price
      return params
    },
    dataParamsPotential() {
      var params = {}
      params.remark = this.$store.state.selected_type
      return params
    },
    dataParamsGroup() {
      var params = {
        page: this.params.page_group,
        per_page: this.params.per_page_group
      }
      params.search_column = 'total_product'
      params.search_operator = '>'
      params.search_text = '0'
      params.show_children = 0
      params.show_product = 0
      return params
    },
    inCartProductIds() {
      const arr = []
      if (this.cart.item && typeof this.cart.item !== 'undefined' && this.cart.item.length) {
        this.cart.item.map(item => {
          if (item.product_id) {
            arr.push(item.product_id)
          }
        })
        return arr
      }
      return arr
    },
    inCartComboIds() {
      const arr = []
      if (this.cart.item && typeof this.cart.item !== 'undefined' && this.cart.item.length) {
        this.cart.item.map(item => {
          if (item.product_combo_id) {
            arr.push(item.product_combo_id)
          }
        })
        return arr
      }
      return arr
    },
    loadedProductGroupIds() {
      const ids = []
      if (this.products.length) {
        this.products.map(item => {
          ids.push(item.product_group_id)
        })
        return ids
      }
      return ids
    }
  },
  watch: {
    item_collection(newItem) {
      this.selected_collection = []
      for (let i = 0; i < newItem.length; i++) {
        if (newItem[i]) {
          this.selected_collection.push(
            this.collections[i].collection_id
          )
        }
      }
    }
  },
  created() {
    this.nav_group[0] = true
  },
  mounted() {
    const LOCAL_DATA_CART = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_cart')
    if (LOCAL_DATA_CART) {
      this.cart = JSON.parse(LOCAL_DATA_CART)
    }
    const DETAIL_TABLE = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_table')
    if (DETAIL_TABLE) {
      this.detail_table = JSON.parse(DETAIL_TABLE)
    }
    this.getGroup()
    this.getCombos()
    this.getFavorite()
    this.getListBanners()
    this.getListCollections()
    this.hitPotentialVoucher()
    window.addEventListener('mouseup', this.onMouseUp)
  },
  destroyed() {
    window.removeEventListener('mouseup', this.onMouseUp)
  },
  methods: {
    detailFavorite(item) {
      if (item.item_type === 'product_combo') {
        this.detailProductCombo(item.item)
      } else {
        this.detailProduct(item.item)
      }
    },
    async deleteVoucher() {
      this.voucher_detail = {}
      this.dialog.voucher_detail = false
      this.$delete(this.cart, 'discount_voucher_id')
      this.$delete(this.cart, 'discount_detail')
      await this.$store.dispatch('saveCartV2', this.cart)
      this.calculation()
    },
    priceFormat(price) {
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    onMouseDown(ev) {
      this.cursorPos = [ev.pageX, ev.pageY]
      window.addEventListener('mousemove', this.onMouseHold)
    },
    onMouseUp(ev) {
      window.removeEventListener('mousemove', this.onMouseHold)
    },
    onMouseHold(ev) {
      ev.preventDefault()
      requestAnimationFrame(() => {
        const delta = [
          ev.pageX - this.cursorPos[0],
          ev.pageY - this.cursorPos[1]
        ]
        this.cursorPos = [ev.pageX, ev.pageY]
        if (!this.$refs.verticalScroll) return
        this.$refs.verticalScroll.scrollBy({
          left: -delta[0],
          top: -delta[1]
        })
      })
    },
    filterDiscount() {
      this.params.page = 1
      this.params.page_combo = 1
      this.combos = []
      this.products = []
      this.filter.is_discount = !this.filter.is_discount
      if (this.filter.is_discount) {
        this.params.search_column.push('is_discount')
        this.params.search_operator.push('=')
        this.params.search_text.push(1)
      } else {
        const index = this.params.search_column.findIndex((e) => {
          return e === 'is_discount'
        })
        this.params.search_column.splice(index, 1)
        this.params.search_operator.splice(index, 1)
        this.params.search_text.splice(index, 1)
      }
      this.getCombos()
    },
    filterSortPrice() {
      this.params.page = 1
      this.params.page_combo = 1
      this.combos = []
      this.products = []
      // this.params.search_column = []
      // this.params.search_operator = []
      // this.params.search_text = []
      if (this.filter.is_sort_price === '') {
        this.filter.is_sort_price = 'up'
        this.params.price = 'desc'
      } else if (this.filter.is_sort_price === 'up') {
        this.filter.is_sort_price = 'down'
        this.params.price = 'asc'
      } else {
        this.filter.is_sort_price = ''
        this.params.price = ''
      }
      this.getCombos()
    },
    filterSortCollection() {
      this.openDialogCollection()
    },
    openDialogCollection() {
      this.dialog.collection = true
      document.querySelector('html').style.overflowY = 'hidden'
    },
    closeDialogCollection() {
      this.dialog.collection = false
      document.querySelector('html').style.overflowY = 'scroll'
    },
    applyCollection() {
      this.combos = []
      this.products = []
      this.params.page = 1
      this.params.page_combo = 1
      this.params.show_collections = 1
      this.params.collections = this.selected_collection
      if (this.selected_collection.length === 0) {
        this.selected_collection = []
        this.params.show_collections = 0
        this.params.collections = []
      }
      this.closeDialogCollection()
      this.getCombos()
    },
    async getListCollections() {
      try {
        const { data } = await getDataCollection()
        data.data.map(item => {
          this.collections.push({ ...item })
        })
      } catch (e) {
        this.collections = []
      }
    },
    async getListBanners() {
      try {
        const { data } = await getBanner()
        data.data.map(item => {
          this.banners.push({ ...item })
        })
      } catch (e) {
        this.banners = []
      }
    },
    async getFavorite() {
      try {
        const { data } = await getDataFavoriteV2()
        data.data.map(item => {
          let is_available = true
          if (item.is_out_stock) {
            is_available = false
          }
          this.$set(item, '__cart_data', { qty: 0, is_available: is_available })
          this.syncProduct(item, item.item_type)
          this.product_favorite.push({ ...item })
        })
      } catch (e) {
        this.product_favorite = []
      }
    },
    loadProduct(e) {
      if (e) {
        this.params.search_column = []
        this.params.search_operator = []
        this.params.search_text = []
        this.params.page = 1
        this.params.per_page = 20
        this.params.page_combo = 1
        this.params.per_page_combo = 20
        this.params.page_group = 1
        this.params.per_page_group = 20
        this.products = []
        this.total_product = 0
        this.product_search = true
        this.combos = []
        this.total_combo = 0
        this.combo_search = true
        this.combo_meta_total = 0
        this.menu = []
        this.total_menu = 0
        this.nav_group[0] = true
        this.product_favorite = []
        this.banners = []
        this.collections = []
        this.potential_discount = {}
        const LOCAL_DATA_CART = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_cart')
        if (LOCAL_DATA_CART) {
          this.cart = JSON.parse(LOCAL_DATA_CART)
        }
        const DETAIL_TABLE = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_table')
        if (DETAIL_TABLE) {
          this.detail_table = JSON.parse(DETAIL_TABLE)
        }
        this.getGroup()
        this.getCombos()
        this.getFavorite()
        this.getListBanners()
        this.getListCollections()
        this.hitPotentialVoucher()
      }
    },
    goToCheckout() {
      this.$router.push({ name: '_checkout' }).catch(() => {})
    },
    onScrollMenu: debounce(async function(e) {
      if (this.settingScroll.group === false && (e.target.clientWidth + e.target.scrollLeft + 100) >= e.target.scrollWidth) {
        this.getGroup()
      }
    }, 500),
    async handleClickMenu(id, i) {
      await this.scrollTo('product', id)
      if (this.menu.length < this.total_menu && (i + 1) === this.menu.length) {
        this.getGroup()
      }
    },
    async scrollTo(type = 'product_combo', id = null) {
      const options = { offset: 110 }
      if (type === 'product_combo') {
        this.$vuetify.goTo('#list-combo', options)
      } else {
        if (typeof this.$refs['list-product-' + id] !== 'undefined') {
          this.$vuetify.goTo('#list-product-' + id, options)
        } else {
          this.getProducts(type, id)
        }
      }
    },
    async getGroup() {
      try {
        const { data } = await getGroupList(this.dataParamsGroup)
        this.settingScroll.group = (data.data.length < this.params.per_page_group)
        this.total_menu = data.meta.total
        await data.data.map(item => {
          this.menu.push({
            id: item.id,
            name: item.name
          })
        })
        this.params.page_group++
      } catch (e) {
        console.log(e)
      }
    },
    scrollItemMenu: debounce(async function(e) {
      if (this.settingScroll.group === false && (e.target.clientHeight + e.target.scrollTop + 100) >= e.target.scrollHeight) {
        this.getGroup()
      }
    }, 500),
    searchProduct: debounce(async function(val) {
      this.params.page = 1
      this.params.page_combo = 1
      this.combos = []
      this.products = []
      this.params.search_column = []
      this.params.search_operator = []
      this.params.search_text = []
      this.params.search_column.push('name')
      this.params.search_operator.push('like')
      this.params.search_text.push(val || '')
      this.is_searching = !(val = !val)
      this.getCombos()
    }, 1000),
    scrollLoadProduct: debounce(async function() {
      if (this.combos.length < this.combo_meta_total) {
        if (this.settingScroll.combo === false) {
          if ((window.innerHeight + window.scrollY + 100) >= document.body.offsetHeight) {
            this.getCombos()
          }
        }
      } else {
        if (this.settingScroll.product === false) {
          if ((window.innerHeight + window.scrollY + 100) >= document.body.offsetHeight) {
            this.getProducts()
          }
        }
      }
    }, 500),
    async setActiveClassNav(type = 'product_combo', idx = 0) {
      this.nav_group = []
      this.active_tab.width = 0
      if (type === 'product_combo') {
        this.active_tab.left = 0
        await this.$set(this.nav_group, 0, true)
      } else {
        await this.$set(this.nav_group, (idx + 1), true)
        let sum = 0
        let width_text = 0
        for (let i = 0; i <= (idx + 1); i++) {
          if ((idx + 1) === i) {
            sum = (idx + 1) * (16 * 2)
          }
          if (i !== 0) {
            const width_nav = '.tab-item.tab-item-' + (i - 1)
            width_text = width_text + this.$el.querySelector(width_nav).offsetWidth
          }
        }
        this.active_tab.left = width_text + sum
      }
      this.active_tab.width = this.$el.querySelector('.tab-item.active').offsetWidth
      if (this.active_tab.left + this.active_tab.width > this.$refs['group-nav'].clientWidth && !this.$vuetify.breakpoint.xs) {
        this.menu_translateX = -((this.active_tab.left + this.active_tab.width) - this.$refs['group-nav'].clientWidth) + -42
      } else {
        this.menu_translateX = 0
      }
    },
    onScrollItem() {
      this.scrollLoadProduct()
      if (!this.is_searching) {
        const combos = {
          id: null,
          name: 'combo'
        }
        const list_menu = [...this.menu]
        const newArr = [combos].concat(list_menu)
        for (let i = 0; i < newArr.length; i++) {
          if (i === 0) {
            const ref_combo = 'list-combo'
            if (typeof this.$refs[ref_combo] !== 'undefined') {
              if (this.$refs[ref_combo].$el.getBoundingClientRect().top < window.innerHeight - (window.innerHeight - 200)) {
                this.setActiveClassNav()
              }
            }
          } else {
            const ref_section = 'list-product-' + this.menu[i - 1].id
            if (typeof this.$refs[ref_section] !== 'undefined') {
              if (this.$refs[ref_section][0].$el.getBoundingClientRect().top < window.innerHeight - (window.innerHeight - 200)) {
                this.setActiveClassNav('product', i - 1)
              }
            }
          }
        }
      }
    },
    getCartItemIdentity(item) {
      const addonsKey = (item.addons || [])
        .map(a => `${a.product_addon_id}-${a.product_addon_variant_id || ''}`)
        .sort()
        .join(',')
      const comboItemsKey = (item.product_combo_items || [])
        .map(c => `${c.id}-${c.children_id || ''}-${c.variant_id || ''}`)
        .sort()
        .join(',')
      return [
        item.product_id,
        item.product_combo_id,
        item.product_variant_id,
        item.note || '',
        addonsKey,
        comboItemsKey
      ].join('|')
    },
    async addCart(form, type) {
      if (this.$isEmpty(this.cart) && typeof this.cart.item === 'undefined') {
        this.cart.item = []
      }
      const index = this.cart.item.findIndex((e) => {
        if (typeof e.product_type !== 'undefined' && e.product_type === 'point') {
          return false
        }
        return this.getCartItemIdentity(e) === this.getCartItemIdentity(form)
      })

      if (index === -1) {
        await this.cart.item.push({ ...form })
      } else {
        const arrTemp = []
        if (typeof this.cart.item[index].materials !== 'undefined' && this.cart.item[index].materials.length > 0 && typeof form.materials !== 'undefined' && form.materials.length > 0) {
          this.cart.item[index].materials.map((item) => {
            form.materials.map((data) => {
              if (data.material_product_id === item.material_product_id) {
                item.qty_in_cart = item.qty_in_cart + data.qty_in_cart
              }
            })
            arrTemp.push(item)
          })
        }
        this.cart.item[index].materials = await [...arrTemp]
        this.cart.item[index].qty = await this.cart.item[index].qty + form.qty
        this.cart.item[index].sub_total = await this.cart.item[index].sub_total + form.sub_total
      }

      if (type === 'product_combo') {
        this.combos.map(item => {
          if (item.id === form.product_combo_id) {
            item.__cart_data.qty = this.countInCartMultipleSameIds(item.id)
          }
        })
      } else if (type === 'product') {
        const selectedProductGroup = await this.products.filter(item => {
          return item.product_group_id === form.klasifikasi_id
        })
        if (selectedProductGroup.length) {
          await selectedProductGroup[0].items.map(async item => {
            if (item.id === form.product_id) {
              let is_available = true
              if (item.has_variant === 0) {
                if (item.track_inventory !== 0) {
                  if (Number(item.stock_qty) === this.countInCartMultipleSameIds(item.id, 'product')) {
                    is_available = false
                  }
                }
              } else {
                const tempCart = { ...this.cart }
                is_available = false
                for (let x = 0; x < item.variants.length; x++) {
                  const variant = item.variants[x]
                  if (item.track_inventory) {
                    if (form.product_variant_id === variant.id) {
                      if (Number(variant.stock_qty) > this.stockCart(variant.id, 'variant') + form.qty + Number(variant.hold_qty)) {
                        is_available = true
                        break
                      }
                    } else {
                      if (Number(variant.stock_qty) > this.stockCart(variant.id, 'variant') + Number(variant.hold_qty)) {
                        is_available = true
                        break
                      }
                    }
                  } else {
                    is_available = true
                  }
                }
                this.cart = tempCart
              }
              item.__cart_data.qty = this.countInCartMultipleSameIds(item.id, 'product')
              item.__cart_data.is_available = is_available
            }
          })
        }
      }
      await this.$store.dispatch('saveCartV2', this.cart)
    },
    countInCartMultipleSameIds(itemId, type = 'product_combo') {
      return this.cart.item.filter(inCartItem => {
        return inCartItem[type + '_id'] === itemId
      }).reduce((acc, curr) => {
        return acc + curr.qty
      }, 0)
    },
    async syncProduct(item, type) {
      let sourceIds = this.inCartProductIds
      if (type === 'product_combo') {
        sourceIds = this.inCartComboIds
      }
      if (sourceIds.includes(item.id)) {
        let is_available = true
        if (item.has_variant === 0) {
          if (item.track_inventory !== 0) {
            if (Number(item.stock_qty) === this.countInCartMultipleSameIds(item.id, 'product')) {
              is_available = false
            } else {
              is_available = true
            }
          }
        }
        item.__cart_data.qty = this.countInCartMultipleSameIds(item.id, 'product')
        item.__cart_data.is_available = is_available
        if (type === 'product_combo') {
          item.__cart_data.qty = this.countInCartMultipleSameIds(item.id)
        }
      }
    },
    async detailBanner(item) {
      if (item.category === 'K') {
        this.showSelectedDiscount(item.items[0].discount_voucher_id)
      } else if (item.category === 'C') {
        this.detailProductCombo({ id: item.items[0].product_combo_id })
      } else if (item.category === 'P') {
        this.detailProduct({
          id: item.items[0].product_id,
          variant_id: item.items[0].product_variant_id
        })
      }
    },
    async getCombos() {
      try {
        this.loading.product = true
        const { data } = await getProductCombo(this.dataParamsCombo)
        this.settingScroll.combo = (data.data.length < this.params.per_page_combo)
        this.total_combo = data.meta.total
        this.combo_meta_total = data.meta.total
        this.combo_search = data.meta.total > 0
        data.data.map(item => {
          let is_available = true
          if (item.is_out_stock) {
            is_available = false
          }
          this.$set(item, '__cart_data', { qty: 0, is_available: is_available })
          this.syncProduct(item, 'product_combo')
          this.combos.push({ ...item })
        })
        if (this.combos.length === data.meta.total) {
          await this.getProducts()
        }
        this.params.page_combo++
      } catch (e) {
        if (e.statusCode === 404) {
          await this.getProducts()
        }
        this.settingScroll.combo = true
        this.combos = []
        this.total_combo = 0
        this.combo_search = false
      } finally {
        this.loading.product = false
      }
    },
    async getProducts(type = 'product_combo', id = null) {
      try {
        this.loading.product = true
        const { data } = await getProduct(this.dataParams)
        this.settingScroll.product = (data.data.length < this.params.per_page)
        const data_product = data.data
        this.total_product = data.meta.total
        this.product_search = data.meta.total > 0
        await data_product.map(item => {
          let is_available = true
          if (item.has_variant === 0) {
            if (item.track_inventory !== 0) {
              if (Number(item.stock_qty) <= 0) {
                is_available = false
              } else {
                is_available = true
              }
            }
          }
          this.$set(item, '__cart_data', { qty: 0, is_available: is_available })
          this.syncProduct(item, 'product')
          if (!this.loadedProductGroupIds.includes(item.klasifikasi_id)) {
            this.products.push({
              product_group_id: item.klasifikasi_id,
              product_group_name: item.klasifikasi,
              items: data_product.filter(__data => __data.klasifikasi_id === item.klasifikasi_id)
            })
          } else {
            const products = this.products.filter(group => {
              return item.klasifikasi_id === group.product_group_id
            })
            const index = products[0].items.findIndex((e) => e.id === item.id)
            if (index === -1) {
              products[0].items.push(...data_product.filter(__data => __data.klasifikasi_id === item.klasifikasi_id))
            }
          }
        })
        this.params.page++
        if (id) {
          this.scrollTo(type, id)
        }
        this.active_tab.width = this.$el.querySelector('.tab-item.active').offsetWidth
      } catch (e) {
        this.settingScroll.product = true
        this.products = []
        this.total_product = 0
        this.product_search = false
      } finally {
        this.loading.product = false
      }
    },
    async showSelectedDiscount(id) {
      this.voucher_detail = {}
      const data_hit = { ...this.cart }
      data_hit.remark = this.$store.state.selected_type
      try {
        const { data } = await getDiscountDetail(id, data_hit)
        this.dialog.voucher_detail = true
        this.voucher_detail = data.data
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async detailProduct(item) {
      try {
        const { data } = await getDetailProduct(item.id)
        this.detail_product.type = 'product'
        this.detail_product.sheet = true
        this.detail_product.item = data.data
        if (item.variant_id) {
          const idx = this.detail_product.item.variants.findIndex((e) => e.id === item.variant_id)
          if (idx !== -1) {
            this.detail_product.default = {
              addons: [],
              has_material: this.detail_product.item.has_material,
              hold_qty: this.detail_product.item.variants[idx].hold_qty,
              is_out_stock: this.detail_product.item.variants[idx].is_out_stock,
              is_takeaway: false,
              klasifikasi_id: this.detail_product.item.klasifikasi_id,
              materials: [],
              name: this.detail_product.item.name,
              non_service_charge: this.detail_product.item.non_service_charge,
              non_taxable: this.detail_product.item.non_taxable,
              note: '',
              product_combo_id: null,
              product_combo_items: [],
              product_id: this.detail_product.item.id,
              product_variant_id: item.variant_id,
              product_variant_name: this.detail_product.item.variants[idx].name,
              qty: 1,
              sell_price: this.detail_product.item.variants[idx].sell_price,
              stock_qty: this.detail_product.item.variants[idx].stock_qty,
              sub_total: this.detail_product.item.variants[idx].sell_price,
              track_inventory: this.detail_product.item.track_inventory
            }
          }
        }
        document.querySelector('html').style.overflowY = 'hidden'
      } catch (e) {
        console.log(e)
      }
    },
    async detailProductCombo(item) {
      try {
        const { data } = await getDetailProductCombo(item.id)
        this.detail_product.type = 'product_combo'
        this.detail_product.sheet = true
        this.detail_product.item = data.data
        document.querySelector('html').style.overflowY = 'hidden'
      } catch (e) {
        console.log(e)
      }
    },
    stockCart(id, type = 'product') {
      var qty = 0
      const LOCAL_DATA_CART = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_cart')
      if (LOCAL_DATA_CART) {
        this.cart = JSON.parse(LOCAL_DATA_CART)
      }
      if (!this.$isEmpty(this.cart) && typeof this.cart.item !== 'undefined' && this.cart.item.length > 0) {
        for (var i = 0; i < this.cart.item.length; i++) {
          if (type === 'variant') {
            if (this.cart.item[i].product_variant_id && Number(this.cart.item[i].product_variant_id) === id) {
              qty = qty + (this.isEdit ? this.detail_product.key === i ? 0 : this.cart.item[i].qty : this.cart.item[i].qty)
            }
            if (this.cart.item[i].product_combo_id) {
              for (var y = 0; y < this.cart.item[i].product_combo_items.length; y++) {
                if (this.cart.item[i].product_combo_items[y].variant_id && Number(this.cart.item[i].product_combo_items[y].variant_id) === id) {
                  qty = qty + ((this.isEdit ? this.detail_product.key === i ? 0 : this.cart.item[i].qty : this.cart.item[i].qty) * this.cart.item[i].product_combo_items[y].qty)
                }
              }
            }
          } else {
            if (this.cart.item[i].product_id && Number(this.cart.item[i].product_id) === id) {
              qty = qty + (this.isEdit ? this.detail_product.key === i ? 0 : this.cart.item[i].qty : this.cart.item[i].qty)
            }
            if (this.cart.item[i].product_combo_id) {
              for (var z = 0; z < this.cart.item[i].product_combo_items.length; z++) {
                if (this.cart.item[i].product_combo_items[z].id && Number(this.cart.item[i].product_combo_items[z].id) === id) {
                  qty = qty + ((this.isEdit ? this.detail_product.key === i ? 0 : this.cart.item[i].qty : this.cart.item[i].qty) * this.cart.item[i].product_combo_items[z].qty)
                }
              }
            }
          }
        }
      }
      return qty
    },
    async hitVoucher(id) {
      const data_hit = { ...this.cart }
      data_hit.discount_id = id
      data_hit.remark = this.$store.state.selected_type
      this.$delete(this.cart, 'discount_voucher_id')
      this.$delete(this.cart, 'discount_detail')
      try {
        const { data } = await hitDataDiscount(data_hit)
        this.cart.discount_voucher_id = id
        this.$set(this.cart, 'discount_detail', data.data)
        await this.$store.dispatch('saveCartV2', this.cart)
        if (this.dialog.voucher_detail) {
          this.dialog.voucher_detail = false
        }
        this.$store.state.show_error = true
        this.$store.state.error_message = this.$t('v2.discount_successfully_used')
        this.$store.state.error_type = 200
      } catch (e) {
        if (e.statusCode === 401) {
          this.$store.dispatch('fetchToken')
        } else {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    },
    async hitPotentialVoucher() {
      const data_hit = { ...this.cart }
      try {
        const { data } = await hitDataPotentialDiscount(data_hit, this.dataParamsPotential)
        this.potential_discount = data.data
      } catch (e) {
        if (e.statusCode === 401) {
          this.$store.dispatch('fetchToken')
        } else {
          this.potential_discount = {}
          return false
        }
      }
    },
    openListCombo(data) {
      this.combo_index = data.index
      this.list_commodity = data.commodity
      this.selectedCommodity = data.selected
      this.sheet_list_combo = true
    }
  }
}
</script>
